export const GetAllCategorization = async (resource) => {
    let result
    await resource
        .get(`api/${localStorage.getItem('perfil')}/categorization`)
        .then(
            (response) => {
                result = response.body.categorization
            },
            (response) => {
                console.log(response);
            }
        );
    return result;
}
export const CategorizationFindByStablishmentId = async (resource,id) => {
    let result
    await resource
        .get(`api/${localStorage.getItem('perfil')}/categorization/find_by_stablishment_id/${id}`)
        .then(
            (response) => {
                result = response.body.categorization
            },
            (response) => {
                console.log(response);
            }
        );
    return result;
}